import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { User } from '../../types'

export interface AuthState {
    user: User | null
    token: string | null
    isAuthenticated: boolean
}

const initialState: AuthState = {
    user: null,
    token: localStorage.getItem('access_token'),
    isAuthenticated: !!localStorage.getItem('access_token'),
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action: PayloadAction<{ user: User; token: string }>) => {
            state.user = action.payload.user
            state.token = action.payload.token
            state.isAuthenticated = true
            localStorage.setItem('access_token', action.payload.token)
        },
        setToken: (state, action: PayloadAction<string>) => {
            state.token = action.payload
            state.isAuthenticated = true
            localStorage.setItem('access_token', action.payload)
        },
        setUser: (state, action: PayloadAction<User>) => {
            state.user = action.payload
        },
        logout: (state) => {
            state.user = null
            state.token = null
            state.isAuthenticated = false
            localStorage.removeItem('access_token')
            localStorage.removeItem('refresh_token')
        },
    },
})

export const { setCredentials, setToken, setUser, logout } = authSlice.actions
export default authSlice.reducer

// Selectors
export const selectCurrentUser = (state: { auth: AuthState }) => state.auth.user
export const selectIsAuthenticated = (state: { auth: AuthState }) => state.auth.isAuthenticated
export const selectUserRole = (state: { auth: AuthState }) => state.auth.user?.role
